export default __webpack_public_path__ + "static/media/banner.da509d73.png";